export class PSDatosGeneralesModel {
    ID: number = 0;
    refPS: string = null;
    clienteId: number = null;
    finalidadId: number = null;
    normativaId: number = null;
    importePresupuesto: number = 0;
    responsableClienteId: number = null;
    responsableClienteNombre: string = null;
    sectorId: number = null;
    sectorNombre: string = null;
    te_PPA: string = null;
    te_Val_Maquinaria: string = null;
    te_Val_Inmobiliaria: string = null;
    te_Val_Intangibles: string = null;
    te_Val_Empresa: string = null;
    te_Val_Otros: string = null;
    te_Val_Consultoria: string = null;
    deadline: Date = null;
    fechaFin: Date = null;
    estadoPS: number = 0;
    estadoNombre: string = null;
}

export enum ValoresEstadoPS {
    EnCurso = 0,
    Finalizado = 5,
    Anulado = 9
}
